import React from 'react';
import { CheckCircle } from 'lucide-react';
import { SKETCHPLAN_PRICING_COPY } from '@rehub/pricing';

interface OrderConfirmedProps {
  email: string;
  jobNumber?: string | null;
  onCreateAccount: () => void;
  onSignIn: () => void;
}

const OrderConfirmed: React.FC<OrderConfirmedProps> = ({
  email,
  jobNumber,
  onCreateAccount,
  onSignIn,
}) => {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/75 backdrop-blur-md p-4">
      <div className="bg-gradient-to-b from-slate-800 to-slate-900 rounded-3xl p-8 max-w-lg w-full shadow-2xl border border-slate-700/50 text-center">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-500/20 to-emerald-500/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle size={40} className="text-green-400" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-3">Your order is confirmed</h2>
        <p className="text-slate-300 leading-relaxed mb-4">
          Payment has been received and your Sketchplan order is now being prepared.
        </p>
        <p className="text-slate-400 leading-relaxed mb-6">
          Create your ReHub account or sign in using the same email address to manage the project, view updates, request your included amendment and download the completed plans.
        </p>
        <p className="text-xs text-slate-500 leading-relaxed mb-6">{SKETCHPLAN_PRICING_COPY.amendmentLong}</p>
        {jobNumber && (
          <p className="text-sm text-slate-500 mb-6">Order reference: <span className="text-slate-200 font-medium">{jobNumber}</span></p>
        )}
        <p className="text-xs text-slate-500 mb-6">We’ll use {email} for account access.</p>
        <button
          type="button"
          onClick={onCreateAccount}
          className="w-full py-4 rounded-xl font-semibold text-white bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-500 hover:to-cyan-500 transition-all mb-3"
        >
          Create Account and Manage Order
        </button>
        <button
          type="button"
          onClick={onSignIn}
          className="w-full py-3 rounded-xl font-medium text-slate-200 bg-slate-800 hover:bg-slate-700 border border-slate-600 transition-all"
        >
          Already have an account? Sign In
        </button>
      </div>
    </div>
  );
};

export default OrderConfirmed;
